<template>
  <b-modal :id="modalId" title="Upload Image" hide-footer>
    <loading-screen :is-loading="isUploading"></loading-screen>
    <errors :error-list="serverErrors"></errors>

    <!-- Preview existing image -->
    <div v-if="existingImageUrl" class="mb-4">
      <h6>Current Image:</h6>
      <div class="current-image-preview">
        <img :src="existingImageUrl" class="img-thumbnail" style="max-height: 200px;">
        <div class="mt-2 text-center">
          <button class="btn btn-danger btn-sm" @click="removeImage">
            <i class="fas fa-trash"></i> Remove Image
          </button>
        </div>
      </div>
    </div>

    <!-- Upload media -->
    <div v-if="!existingImageUrl" class="upload-media">
      <el-upload
        :http-request="uploadFile"
        class="upload-demo"
        drag
        :action="uploadUrl"
        :file-list="fileList"
        :accept="acceptedFileTypes"
        :multiple="false"
        :auto-upload="true"
        :limit="1"
        :on-exceed="handleExceed"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop image here or <em>click to upload</em></div>
        <div class="el-upload__tip" slot="tip">Only jpg/png/jpeg files are allowed</div>
      </el-upload>
    </div>
    <!-- / Upload media -->

    <!-- <div class="mt-3 text-right">
      <button type="button" class="btn btn-light" @click="closeModal">Close</button>
    </div> -->
  </b-modal>
</template>

<script>
import axios from "axios";
import Forms from "../../../../../../mixins/Forms";

export default {
  name: "UploadWhatsappMediaModal",
  mixins: [Forms],
  props: {
    modalId: {
      type: String,
      required: true
    },
    ticketId: {
      type: [String, Number],
      required: true
    },
    existingImageUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isUploading: false,
      serverErrors: [],
      fileList: [],
      acceptedFileTypes: "image/jpeg,image/png,image/jpg"
    };
  },
  computed: {
    uploadUrl() {
      return `${API_BASE}/tickets/${this.ticketId}/media`;
    }
  },
  methods: {
    handleExceed() {
      this.$notify.warning({
        title: "Warning",
        message: "Only one image can be uploaded at a time"
      });
    },

    uploadFile(params) {
      let vm = this;
      vm.isUploading = true;
      vm.serverErrors = [];

      const formData = new FormData();
      formData.append("file", params.file);

      axios
        .post(vm.uploadUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((r) => {
          vm.isUploading = false;
          vm.$emit("file-uploaded", r.data);
        })
        .catch((e) => {
          vm.isUploading = false;
          vm.setErrors(e);
        });
    },

    removeImage() {
      this.$emit('remove-image');
      this.closeModal();
    },

    closeModal() {
      this.$bvModal.hide(this.modalId);
    }
  }
};
</script>

<style scoped>
.upload-media {
  min-height: 200px;
}

.current-image-preview {
  text-align: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}
</style>
